import { render, staticRenderFns } from "./NpaComments.vue?vue&type=template&id=4d068cbb&scoped=true"
import script from "./NpaComments.vue?vue&type=script&lang=js"
export * from "./NpaComments.vue?vue&type=script&lang=js"
import style0 from "./NpaComments.vue?vue&type=style&index=0&id=4d068cbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d068cbb",
  null
  
)

export default component.exports